/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=85ac378c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=85ac378c&lang=less&scoped=true"

import exportComponent from "/Users/zhangwenting/Code/Vlian/vlian-pc-vue3/node_modules/.pnpm/vue-loader@17.0.1_vue@3.2.45+webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85ac378c"]])

export default __exports__